/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBearLeft = createReactComponent("arrow-bear-left", "IconArrowBearLeft", [
  ["path", { d: "M13 3h-5v5", key: "svg-0" }],
  ["path", { d: "M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93", key: "svg-1" }]
]);

export { IconArrowBearLeft as default };
//# sourceMappingURL=IconArrowBearLeft.js.map
